import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../components/Hint/Hint';
import SortableAccordion from '../components/SortableAccordion/SortableAccordion';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const SecurityAddressBlacklist = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable Address Blacklist", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Blacklist specific addresses from the WooCommerce store, wherever the address is validated.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable address blacklist", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable address blacklist", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.address_blacklist.enable"
                                    checked={settingData?.security?.address_blacklist?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Percentage of similarity", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Set the similarity percentage of the address you want to apply to your site.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set percentage similarity", "ultimate-security")}/>
                                    <div className="d-flex align-items-center">
                                        <span className="w-130">
                                            <input 
                                                className="form-control"
                                                type="number"
                                                min="0"
                                                value={settingData?.security?.['address_blacklist']?.percentage}
                                                onChange={(e) => handleChange('security.address_blacklist.percentage', e.target.value)}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Blacklisted addresses", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Add the addresses you want to blacklist. Set the address and enable them according to your requirements.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable address blacklist", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.address_blacklist.enable_blacklisted_addresses"
                                    checked={settingData?.security?.address_blacklist?.enable_blacklisted_addresses} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint content={__("Click to add new address", "ultimate-security")}/>
                                    <SortableAccordion 
                                        name='security.address_blacklist.blacklisted_addresses'
                                        options={{
                                            addButton: 'Add New Field',
                                            titlePrefix: 'Address',
                                            enabler: true,
                                        }}
                                        fields={
                                            [
                                                { type: "input", name: "title", placeholder: "Address 1", className: "form-control", label: "Title" },

                                                { type: "input", name: "address_1", placeholder: "Address 1", className: "form-control", label: "Address 1" },
                                                { type: "input", name: "address_2", placeholder: "Address 2", className: "form-control", label: "Address 2" },
                                                { type: "input", name: "city", placeholder: "City", className: "form-control", label: "City" },
                                                { type: "input", name: "postcode", placeholder: "Postcode", className: "form-control", label: "Postcode" },
                                                { type: "input", name: "country", placeholder: "Country", className: "form-control", label: "Country" },
                                                { type: "input", name: "state", placeholder: "State", className: "form-control", label: "State" },
                                                
                                            ]
                                        } 
                                        // savedData={savedData} 
                                        savedData={settingData?.security?.address_blacklist?.blacklisted_addresses} 
                                        handleChange={handleChange}
                                    />
                                </div>
                            </div>     
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityAddressBlacklist, 'security.address_blacklist');